import AddFilesModal from './AddFilesModal';

export default AddFilesModal;
